import { render, staticRenderFns } from "./RisSuggestion.vue?vue&type=template&id=17cf28a2&scoped=true"
import script from "./RisSuggestion.vue?vue&type=script&lang=js"
export * from "./RisSuggestion.vue?vue&type=script&lang=js"
import style0 from "./RisSuggestion.vue?vue&type=style&index=0&id=17cf28a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cf28a2",
  null
  
)

export default component.exports